module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/components/AnnouncementsCard/images/announcement_create_icon.521d1d1e.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/components/AnnouncementsCard/images/announcement_create_icon.png
// module id = 2882
// module chunks = 11